module.exports = __webpack_public_path__ + "static/media/arrow-square-right.1695f8ef.svg";